import api from "./axios";
// Backend accepts an inclusive range { from?: YYYY-MM-DD, to?: YYYY-MM-DD }
// or the legacy { date?: YYYY-MM-DD }. Defaults to today on both ends.
// Ranged ops are queued: these answer 202 with { run_id }, and progress is
// read off getOpsRun below. See useOpsRun for the polling loop.
export const generateTasks = (payload = {}) => api.post("/ops/tasks/generate", payload);
export const sendReminders = (payload = {}) => api.post("/ops/reminders/send", payload);

// Run status — shared by the task and payment ops.
export const getOpsRun = (runId) => api.get(`/ops/runs/${runId}`);
export const cancelOpsRun = (runId) => api.post(`/ops/runs/${runId}/cancel`);
export const listOpsRuns = (params = {}) => api.get("/ops/runs", { params });
